import { OperationMiciCase, MiciCaseFilter } from '../../../services/types/Operation';
import { Action, ApiState } from '../../../types';
import { callService, serviceReducer } from '../../../shared/hooks/serviceReducer';
import { Paged } from '../../../services/types/Misc';

export type OperMissionAction =
  | Action<Paged<OperationMiciCase>, MiciCaseFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<Paged<OperationMiciCase>, MiciCaseFilter>,
  action: OperMissionAction
): ApiState<Paged<OperationMiciCase>, MiciCaseFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
